export default "__VITE_ASSET__BYAfOtHl__"